// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header_ZT8DtHv","divider":"header_divider_3KEfU6H"};